import plugins from './plugins'
import vuetify from './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import store from './store'
import AsyncComputed from 'vue-async-computed'
import 'scrolling-element'
import './directives/Style'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import FlagIcon from 'vue-flag-icon'
import PortalVue from 'portal-vue'
import PrismicVue from '@prismicio/vue'
import { VTextField } from 'vuetify/lib' // Globally import VTextField
import '@/plugins/vue-tour.js'
import '@/plugins/capacitor.js'
import IdleVue from "idle-vue"
import {EventBus} from "./plugins/fincraft"
import AmplitudePush from "@/mixins/AmplitudePush"
import VueI18n from 'vue-i18n'

Vue.component('v-text-field', VTextField) //see https://phiny1.github.io/v-currency-field/started.html#treeshaking
Vue.use(PortalVue)

Vue.use(PrismicVue, {
  endpoint: "https://finlexicon.prismic.io/api/v2"
})
Vue.component('VueSlider', VueSlider)

Vue.use(AsyncComputed)
Vue.use(VueVirtualScroller)
Vue.use(FlagIcon)

Vue.use(IdleVue, {
  eventEmitter: EventBus,
  store,
  idleTime: parseInt(process.env.VUE_APP_IDLETIME),
  startAtIdle: false
})

Vue.config.productionTip = false

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'de',
  silentTranslationWarn: true,
  messages: {
    en: {
      hello: 'Hi',
      welcome_to_company_name: 'welcome to finCraft!',
      contact: 'Contact',
      you_have_questions_or_issues: 'Do you have questions or discovered a problem?',
      please_contact_our_support: 'Please contact us:'
    },
    de: {
      hello: 'Hey',
      welcome_to_company_name: 'willkommen bei finCraft!',
      contact: 'Kontakt',
      you_have_questions_or_issues: 'Du hast Fragen oder ein Problem entdeckt?',
      please_contact_our_support: 'Wende dich ganz einfach an'
    }
  }
})

const vue = new Vue({
  ...plugins,
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App),
  mixins: [AmplitudePush],
  data() {
    return {
      prevRoute: undefined
    }
  },
  watch: {
    '$route': async function (value) {
      await this.pushToAmplitude({
        'event': `fincraft_pageview_${value.name.toLowerCase()}`,
        'placement': `router`,
        'previousRoute': this.prevRoute?.name,
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.prevRoute = value
    }
  },
  mounted() {
    // The event beforeunload is fired before the current page is unloaded, either via navigation or reload
    // To handle the deeplinks, a reload occurs. This fired this event and stopped the android app to be working.
    document.addEventListener('beforeunload', (e) => {
      console.log("beforeunload event", e)
      vue.$destroy()
    })
  },
  destroyed() {
    document.removeEventListener('beforeunload', (e) => {
      console.log("beforeunload event", e)
      vue.$destroy()
    })
  }
}).$mount('#app')
